import { Resource } from "@domain/base/Resource";
import { IImport4YouConnectorRepository } from "@domain/connection/IMarketplaceRepository";
import { Connection } from "@domain/connection/models/Connection";
import { ConnectionMapper } from "../mappers/MarketplaceMapper";
import { Import4YouInventory } from "@domain/connection/models/Import4YouInventory";
import { Import4YouConnectorDataSource } from "../datasources/Import4YouConnectorDataSource";
import { Import4YouMapper } from "../mappers/Import4YouMapper";
import { InventorySyncEventItem } from '@domain/connection/models/InventorySyncEvent';

export class Import4YouConnectorRepository implements IImport4YouConnectorRepository {

    constructor(private dataSource: Import4YouConnectorDataSource) { }

    async addImport4YouMarketplaceConnection(code: string, redirectUri: string): Promise<Resource<Connection>> {
        try {
            const data = await this.dataSource.addImport4YouConnection(code, redirectUri);
            return {
                status: 'success',
                data: ConnectionMapper.toConnectionModel(data)
            };
        } catch (error) {
            return {
                status: 'error',
                error: {
                    type: 'UnknownError',
                    message: 'Failed to add Monta connection'
                }
            };
        }
    }

    async fetchInventory(connectionId: string): Promise<Resource<Import4YouInventory[]>> {
        try {
            const data = await this.dataSource.fetchInventory(connectionId);
            return {
                status: 'success',
                data: data.map(Import4YouMapper.toInventoryModel)
            };
        }
        catch (error) {
            return {
                status: 'error',
                error: {
                    type: 'UnknownError',
                    message: 'Failed to fetch Import4You inventory'
                }
            };
        }

    }

    async fetchProductsInventory(connectionId: string): Promise<Resource<InventorySyncEventItem[]>> {
        try {
            const data = await this.dataSource.fetchProductsInventory(connectionId);
            return { status: 'success', data };
        }
        catch (error) {
            return { status: 'error', error: { type: 'UnknownError', message: 'Failed to fetch Import4You products inventory' } };
        }
    }

}
